// Main website router (firstcitypoly.edu.ng)
import { createRouter, createWebHistory } from "vue-router";
import { createLogger } from "../utils/logger";
import URLHelper from "../utils/URLHelper";

const logger = createLogger("MainRouter");

// Main Website Views
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ContactView from "../views/ContactView.vue";
import ScholarshipView from "../views/ScholarshipView.vue";
import HowToApplyView from "../views/HowToApplyView.vue";
import DepartmentDetails from "@/components/DepartmentDetails.vue";
import MatricFrame from "@/views/student/MatricFrame.vue";
import PolicyView from "../views/PolicyView.vue";
import TermsAndConditionsView from "../views/TermsAndConditionsView.vue";
import CareersView from "../views/CareersView.vue";
import JobDetailView from "../views/JobDetailView.vue";

// Registration (moved from /app/apply to /apply)
import AppRegisterView from "@/views/student/AppRegisterView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/department/:slug",
    name: "department",
    component: DepartmentDetails,
    props: true,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/funding",
    name: "funding",
    component: ScholarshipView,
  },
  {
    path: "/how-to-apply",
    name: "how-to-apply",
    component: HowToApplyView,
    meta: {
      title: "How to Apply - First City Polytechnic",
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: PolicyView,
    meta: {
      title: "Privacy Policy - First City Polytechnic",
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: TermsAndConditionsView,
    meta: {
      title: "Terms and Conditions - First City Polytechnic",
    },
  },
  {
    path: "/careers",
    name: "careers",
    component: CareersView,
    meta: {
      title: "Careers - First City Polytechnic",
    },
  },
  {
    path: "/careers/:jobId",
    name: "jobDetail",
    component: JobDetailView,
    meta: {
      title: "Job Details - First City Polytechnic",
    },
  },
  {
    path: "/apply",
    name: "register",
    component: AppRegisterView,
    meta: {
      title: "Apply to First City Polytechnic",
      hideHeader: true,
      hideFooter: true,
      guest: true,
    },
  },
  {
    path: "/matric-frame",
    name: "matricFrame",
    component: MatricFrame,
    meta: {
      title: "Matric Frame - First City Polytechnic",
    },
  },
  // Redirect old URLs to new subdomains
  {
    path: "/staff/:pathMatch(.*)*",
    beforeEnter() {
      URLHelper.goToStaff("/");
      return false;
    },
  },
  {
    path: "/app/:pathMatch(.*)*",
    beforeEnter() {
      URLHelper.goToPortal("/");
      return false;
    },
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    } else {
      return { top: 0 };
    }
  },
});

// Add error handling
router.onError((error) => {
  logger.error("Router error:", error);
});

export default router;
